import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

import { includes } from 'lodash';
import { faCaretDown, faSliders } from '@fortawesome/pro-regular-svg-icons';

import { Button } from 'components/ui/button';

export class MobileFilterTopBar extends React.Component {
  static propTypes = {
    assetClasses: PropTypes.array.isRequired,
    availabilities: PropTypes.array.isRequired,
    propertyFilter: PropTypes.object.isRequired,
    saleFilter: PropTypes.object.isRequired,
    selectedAssetClasses: PropTypes.array.isRequired,
    selectedAvailabilities: PropTypes.array.isRequired,
    selectedBuildingClasses: PropTypes.array.isRequired,
    selectedGroupId: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    tags: PropTypes.array.isRequired,
    onDisplayFilters: PropTypes.func.isRequired,
  };

  isSelected(selected, value) {
    return includes(selected || [], value);
  }

  appliedFilters() {
    const {
      assetClasses,
      availabilities,
      selectedAssetClasses,
      selectedAvailabilities,
      selectedBuildingClasses,
      propertyFilter,
      saleFilter,
      tags,
    } = this.props;

    const appliedFilters = [];
    selectedBuildingClasses.forEach(buildingClass => appliedFilters.push(buildingClass)
    );
    tags.forEach(tag => appliedFilters.push(tag));

    Object.keys(saleFilter).forEach((key) => {
      if (saleFilter[key] !== '' && key !== 'leaseRateUnits') {
        appliedFilters.push(saleFilter[key]);
      }
    });

    Object.keys(propertyFilter).forEach((key) => {
      if (propertyFilter[key] !== '' && key !== 'lotUnits') {
        appliedFilters.push(propertyFilter[key]);
      }
    });

    assetClasses.map((asset) => {
      if (this.isSelected(selectedAssetClasses, asset.value)) {
        appliedFilters.push(asset.label);
      }
    });

    availabilities.map((availability) => {
      if (this.isSelected(selectedAvailabilities, availability.value)) {
        appliedFilters.push(availability.label);
      }
    });

    return appliedFilters;
  }

  render() {
    const { onDisplayFilters } = this.props;
    const appliedFilters = this.appliedFilters();

    return (
      <div className="d-lg-none">
        {appliedFilters.length > 0 ? (
          <Button className="w-100" variant="outline" onClick={onDisplayFilters}>
            <span className="filters-count">{appliedFilters.length}</span>
            <strong>Filters:</strong>
            <span className="applied-filters-text">
              {appliedFilters.join(', ')}
            </span>
          </Button>
        ) : (
          <Button
            className="w-100"
            icon={faSliders}
            iconEnd={faCaretDown}
            label="Filters"
            variant="outline"
            onClick={onDisplayFilters}
          />
        )}
      </div>
    );
  }
}

const mapStateToProps = state => ({
  assetClasses: state.static.assetClasses,
  availabilities: state.static.availabilities,
  saleFilter: state.query.saleFilter,
  selectedAvailabilities: state.query.availabilities,
  selectedAssetClasses: state.query.assetClasses,
  selectedBuildingClasses: state.query.buildingClasses,
  propertyFilter: state.query.propertyFilter,
  tags: state.query.tags,
});

export default connect(mapStateToProps, {})(MobileFilterTopBar);
